import React, { useState, useEffect } from 'react';
import { NAVIGATION, SITE_CONFIG } from '@/constants/content';
import { Button } from '@/components/ui/button';
import { Menu, X } from 'lucide-react';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white/95 backdrop-blur-md shadow-md'
          : 'bg-transparent'
      }`}
      data-testid="main-header"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex-shrink-0" data-testid="logo">
            <a href="#" className="flex items-center" data-testid="logo-link">
              <img
                src="/indexone-logo.png"
                alt="INDEXONE - Procesos Digitales"
                className="h-12 w-auto"
                data-testid="logo-image"
              />
            </a>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8" data-testid="desktop-nav">
            {NAVIGATION.map((item) => (
              <button
                key={item.href}
                onClick={() => scrollToSection(item.href)}
                className="text-gray-700 hover:text-blue-900 transition-colors text-sm font-medium"
                data-testid={`nav-link-${item.label.toLowerCase()}`}
              >
                {item.label}
              </button>
            ))}
          </nav>

          {/* Desktop CTAs */}
          <div className="hidden md:flex items-center space-x-4" data-testid="desktop-cta">
            <Button
              variant="outline"
              className="border-blue-900 text-blue-900 hover:bg-blue-50"
              data-testid="client-access-button"
            >
              Acceso Clientes
            </Button>
            <Button
              onClick={() => scrollToSection('#contacto')}
              className="text-white"
              style={{ backgroundColor: '#D7A22F' }}
              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#C4911F'}
              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#D7A22F'}
              data-testid="demo-request-button"
            >
              Solicitar Demo
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-gray-700"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            data-testid="mobile-menu-toggle"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div
          className="md:hidden bg-white border-t border-gray-200"
          data-testid="mobile-menu"
        >
          <nav className="px-4 py-6 space-y-4">
            {NAVIGATION.map((item) => (
              <button
                key={item.href}
                onClick={() => scrollToSection(item.href)}
                className="block w-full text-left text-gray-700 hover:text-blue-900 transition-colors text-base font-medium"
                data-testid={`mobile-nav-${item.label.toLowerCase()}`}
              >
                {item.label}
              </button>
            ))}
            <div className="pt-4 space-y-3">
              <Button
                variant="outline"
                className="w-full border-blue-900 text-blue-900"
                data-testid="mobile-client-access"
              >
                Acceso Clientes
              </Button>
              <Button
                onClick={() => scrollToSection('#contacto')}
                className="w-full text-white"
                style={{ backgroundColor: '#D7A22F' }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#C4911F'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#D7A22F'}
                data-testid="mobile-demo-request"
              >
                Solicitar Demo
              </Button>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};